import { lazy, Suspense, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isUserAuthorized, getCurrentTheme } from "./store/selectors";
import {
  checkToken,
  fetchUserProfile,
  loadInitialData,
} from "./actions/authActions";
import { Loading } from "./layout/utils/AppLoading";
import withClearCache from "./ClearCache";
import { ConfigProvider, theme } from "antd";
import es_ES from "antd/es/locale/es_ES";
import { THEME } from "./constants";
import { getCookie } from "./utils";

const MainContainer = lazy(() => import("./containers/MainContainer"));
const AuthContainer = lazy(() => import("./containers/AuthContainer"));

const App = () => {
  const dispatch = useDispatch();
  const currentTheme = useSelector(getCurrentTheme);

  const { auth } = useSelector(isUserAuthorized) || {};


  const ClearCacheComponent = withClearCache(() => {
    return <></>;
  });

  const fetchInitialData = useCallback(async () => {
    console.log("Fetching initial data")
    dispatch(fetchUserProfile());
    dispatch(loadInitialData());
    console.log("Finish fetching initial data")
  }, [dispatch]);

  const checkPersistency = useCallback(() => {
    dispatch(checkToken());
  }, [dispatch]);

  useEffect(() => {
    auth ? fetchInitialData() : checkPersistency();
  }, [auth, fetchInitialData, checkPersistency]);

  useEffect(() => {
    const refreshTheme = async () => {
      await dispatch({ type: THEME, payload: await getCookie(THEME) })
    }
    refreshTheme()
  }, [dispatch])

  useEffect(() => {
    if (currentTheme) {
      document.body.style.backgroundColor = '#F5F5F5';
    } else {
      document.body.style.backgroundColor = '#38393F';
    }
  }, [currentTheme]);

  return (
    <Suspense fallback={<Loading centered />}>
      <ConfigProvider
        locale={es_ES}
        theme={{
          token: {
            borderRadius: 5,
            colorPrimary: "#003764",
            fontFamily: "Charlie Display",
            colorBgBase: currentTheme ? "#fff" : "#38393F",
            colorTextDisabled: currentTheme ? "rgba(0, 0, 0, 0.50)" : "rgba(255, 255, 255, 0.50)",
          },
          components: {
            Switch: {
              colorPrimary: '#4CAF50',
              colorPrimaryHover: "#4CAF50",
            }
          },
          algorithm: currentTheme ? theme.defaultAlgorithm : theme.darkAlgorithm,
        }}
      >
        <ClearCacheComponent />
        {auth ? <MainContainer /> : <AuthContainer />}
      </ConfigProvider>
    </Suspense>
  );
};

export default App;
